import React from "react";
import * as S from "./styles";
import { API } from "../../../../../shared/services";
import { useDebouncedEffect } from "../../../../../shared/hooks";
import { useMain } from "modules/app/contexts";

function FilterFullText({ searchText, setSearchText }) {
  const { overwriteSearchContacts } = useMain();

  useDebouncedEffect(
    () => {
      if (!searchText) return overwriteSearchContacts([]);

      API.get(`/customers?keywords=${searchText}`).then((result) =>
        overwriteSearchContacts(result.data)
      );
    },
    1000,
    [searchText]
  );

  const handleClean = () => {
    setSearchText("");
  };

  const handleChange = (event) => {
    overwriteSearchContacts([]);
    setSearchText(event.target.value);
  };

  return (
    <S.Container>
      <S.SearchInput
        fullWidth
        autoFocus={false}
        value={searchText}
        onChange={handleChange}
        InputProps={{
          disableUnderline: true,
          placeholder: "Procurar ou começar uma nova conversa",
        }}
        InputLabelProps={{
          shrink: false,
        }}
      />
      {searchText === "" ? (
        <S.SearchIcon />
      ) : (
        <S.CloseButton onClick={handleClean}>
          <S.CloseIcon />
        </S.CloseButton>
      )}
    </S.Container>
  );
}

export default FilterFullText;
